import { store } from '../common/redux_store.js'
import * as Action from '../common/redux_actions.js'
import { database } from '../common/dexie_database.js'

/**
 * Group object
 */
export var Group = function Group(saved_values) {

  var self = this;

  // Set up a place to store what has already been saved so we can compare
  // to what is just in memory.
  this.saved_properties = {};

  this.property_names = [
    'id',
  ];

  // Set up default values.
  this.id = null;

  this.set_saved_values = function (saved_values) {
    // Seed the new object with the saved values. These values should be what
    // is stored in the database.
    $.each(saved_values, function (key, value) {
      if (typeof(value) == 'object' && value != null && !(value instanceof Array)) {
        self[key] = $.extend(true, {}, value);
        self.saved_properties[key] = $.extend(true, {}, value);
      }
      else {
        self[key] = value;
        self.saved_properties[key] = value;
      }
    });
  }

  this.set_saved_values(saved_values);

}

Group.prototype.getCoachCalendarPath = function (callback) {
  return '/coach/group/' + this.id + '/';
}

Group.prototype.getAthleteListPath = function (callback) {
  return '/coach/group/' + this.id + '/athletes/';
}

Group.prototype.getTopicsPath = function (callback) {
  return '/coach/group/' + this.id + '/topics/';
}

Group.prototype.getReportsPath = function (callback) {
  return '/coach/group/' + this.id + '/reports/';
}

Group.prototype.getEditGroupPath = function (callback) {
  return '/coach/group/edit/' + this.id + '/';
}


export var Topic = function Topic(saved_values) {

  this.set_saved_values = (saved_values) => {
    // Seed the new object with the saved values. These values should be what
    // is stored in the database.
    $.each(saved_values, (key, value) => {

      if (typeof(value) == 'object' && value != null && !(value instanceof Array)) {
        value = $.extend(true, {}, value);
      }
      else if (key == 'last_message_datetime' && typeof(value) == 'string') {
        value = xhale.helper.new_zulu_datetime(value);
      }

      this[key] = value;

    });

  }

  this.set_saved_values(saved_values);
}

var global_group_id_to_keep;

var groupLoaded = function (new_data) {

  if (xhale.user_preference.offline_mode.is_enabled()) {
    database.transaction("rw", database.groups, function() {

      // Add the new data to the database and then send it to the Redux store.
      database.groups.put(new_data).then(function () {
        database.groups.toArray(function (items) {
          store.dispatch(Action.groupReceive(items));
        })
      });

    }).catch(function (e) {
      store.dispatch(Action.groupReceive([new_data]));
    });
  }
  else {
    store.dispatch(Action.groupReceive([new_data]));
  }

}

var groupsLoaded = function (new_data) {

  // Update unseen group messages count if collected.
  if ('topics_with_new_messages' in new_data && new_data.topics_with_new_messages) {
    store.dispatch(Action.updateTopicMessagesUnseenList(new_data.topics_with_new_messages.topic_ids, new_data.topics_with_new_messages.group_ids));
  }

  var data_populated_datetime_string = new Date().toISOString();
  var new_table_metadata = {table_name: 'groups', populated_datetime: data_populated_datetime_string };

  if (xhale.user_preference.offline_mode.is_enabled()) {
    database.transaction("rw", database.groups, database.table_metadata, function() {

      // Groups may have been removed so get rid of these from the store and
      // the database.

      var redux_store_state = store.getState();
      var old_data_group_ids = Object.keys(redux_store_state.main.groups);

      // Collect a list of group ids from the recent download.
      var new_data_group_ids = [];
      $.each(new_data.groups, function (key, group) {
        new_data_group_ids.push(group.id);
      });

      // Create a list of group ids to delete which are groups not listed in
      // the refreshed data. Also only delete groups that they are a prescriber
      // of when we've fetched prescriber data and only delete what they are a
      // member of when we've fetched subscriber details.
      var group_ids_to_delete = [];
      for (var i = 0; i < old_data_group_ids.length; i++) {
        if ($.inArray(parseInt(old_data_group_ids[i]), new_data_group_ids) === -1 && parseInt(old_data_group_ids[i]) != global_group_id_to_keep) {

          var old_group_data = redux_store_state.main.groups[parseInt(old_data_group_ids[i])];

          if (old_group_data.current_user_is_prescriber && old_group_data.current_user_is_member) {
            if (new_data.contains_prescriber_groups && new_data.contains_athlete_groups) {
              group_ids_to_delete.push(parseInt(old_data_group_ids[i]))
            }
          }
          else if (old_group_data.current_user_is_prescriber && new_data.contains_prescriber_groups) {
            group_ids_to_delete.push(parseInt(old_data_group_ids[i]))
          }
          else if (old_group_data.current_user_is_member && new_data.contains_athlete_groups) {
            group_ids_to_delete.push(parseInt(old_data_group_ids[i]))
          }

        }
      }

      if (group_ids_to_delete.length > 0) {
        // Remove from the database.
        database.groups.bulkDelete(group_ids_to_delete);

        // Remove from the Redux store.
        store.dispatch(Action.groupRemove(group_ids_to_delete));
      }

      // Add the new data to the database and then send it to the Redux store.
      database.table_metadata.put(new_table_metadata).then(function () {
        database.groups.bulkPut(new_data.groups).then(function (last_key) {
          database.groups.toArray(function (items) {
            store.dispatch(Action.groupReceive(items));
            store.dispatch(Action.tableMetadataReceive(new_table_metadata));
          })
        });
      });

    }).catch(function (e) {
      store.dispatch(Action.groupReceive(new_data.groups));
      store.dispatch(Action.tableMetadataReceive(new_table_metadata));
    });
  }
  else {
    store.dispatch(Action.groupReceive(new_data.groups));
    store.dispatch(Action.tableMetadataReceive(new_table_metadata));
  }

}

/**
 * Load full group data for an individual group.
 */
export var populateIndividualGroupData = function (group_id) {

  // Attempt to load the data from Dexie.
  if (xhale.user_preference.offline_mode.is_enabled()) {

    database.groups.toArray(function (items) {

      // Place these items into the Redux store.
      store.dispatch(Action.groupReceive(items));

    }).then(function () {

      // Finished populating store with current database data. Now ajax in new data.
      $.getJSON('/accounts/load-group/' + group_id + '/').done(groupLoaded);

    }).catch(function (e) {
      $.getJSON('/accounts/load-group/' + group_id + '/').done(groupLoaded);
    });

  }
  else {
    // Dispatch groups table metadata to store with null value as obviously no
    // table data exists at all.
    store.dispatch(Action.tableMetadataReceive({table_name: 'groups', populated_datetime: null }));
    $.getJSON('/accounts/load-group/' + group_id + '/').done(groupLoaded);
  }

}

/**
 * Load a list of groups from an athlete's perspective.
 */
export var populateAthleteGroupsData = function () {

  // Attempt to load the data from Dexie.
  if (xhale.user_preference.offline_mode.is_enabled()) {
    database.table_metadata.get('groups', function (groups_table) {

      var groups_table = (groups_table) ? groups_table : {table_name: 'groups', populated_datetime: null};

      database.groups.toArray(function (items) {

        // Place these items into the Redux store.
        store.dispatch(Action.groupReceive(items));

      }).then(function () {

        // Dispatch groups table metadata to store.
        store.dispatch(Action.tableMetadataReceive(groups_table));

        // Finished populating store with current database data. Now ajax in new data.
        $.getJSON('/accounts/load-groups/?athlete=yes&prescriber=yes').done(groupsLoaded);

      }).catch(function (e) {
        $.getJSON('/accounts/load-groups/?athlete=yes&prescriber=yes').done(groupsLoaded);
      });

    });

  }
  else {
    // Dispatch groups table metadata to store with null value as obviously no
    // table data exists at all.
    store.dispatch(Action.tableMetadataReceive({table_name: 'groups', populated_datetime: null }));
    $.getJSON('/accounts/load-groups/?athlete=yes&prescriber=yes').done(groupsLoaded);
  }

}


/**
 * Load a list of groups from a coach's perspective.
 */
export var populateCoachGroupData = function (group_id_to_keep) {

  // Register that we want to not delete a specific group. This is useful
  // for super users accessing groups not on account.
  if (group_id_to_keep) {
    global_group_id_to_keep = group_id_to_keep;
  }

  // Attempt to load the data from Dexie.
  if (xhale.user_preference.offline_mode.is_enabled()) {
    database.table_metadata.get('groups', function (groups_table) {

      var groups_table = (groups_table) ? groups_table : {table_name: 'groups', populated_datetime: null};

      database.groups.toArray(function (items) {

        // Place these items into the Redux store.
        store.dispatch(Action.groupReceive(items));

      }).then(function () {

        // Dispatch groups table metadata to store.
        store.dispatch(Action.tableMetadataReceive(groups_table));

        // Finished populating store with current database data. Now ajax in new data.
        $.getJSON('/accounts/load-groups/?prescriber=yes&athlete=no').done(groupsLoaded);

      }).catch(function (e) {
        $.getJSON('/accounts/load-groups/?prescriber=yes&athlete=no').done(groupsLoaded);
      });

    });

  }
  else {
    // Dispatch groups table metadata to store with null value as obviously no
    // table data exists at all.
    store.dispatch(Action.tableMetadataReceive({table_name: 'groups', populated_datetime: null }));
    $.getJSON('/accounts/load-groups/?prescriber=yes&athlete=no').done(groupsLoaded);
  }

}

